<template>
    <Slide :title="title" :subtitle="subtitle">
        <div class="cr:grid cr:grid-cols-2 cr:md:grid-cols-3 cr:text-sm">
            <div v-for="stateOption in stateOptions" class="cr:flex cr:items-center cr:gap-2 cr:p-1 cr:my-1">
                <CustomCheckbox v-model="stateOption.selected"/>
                <p>{{ stateOption.name }}</p>
            </div>
        </div>
    </Slide>
</template>

<script setup lang="ts">

import Slide from "@/components/slides/Slide.vue";
import CustomCheckbox from "@/components/elements/CustomCheckbox.vue";
import {computed, onMounted, type Ref, ref} from "vue";
import {useRegistrationStore} from "@/stores/registration.ts";
import {useErrorStore} from "@/stores/error.ts";

interface State {
    abbr: string,
    name: string,
    selected: boolean
}

const props = defineProps({
    title: {
        type: String,
        default: 'What states are you licensed in?'
    },
    subtitle: {
        type: String,
        default: ''
    }
});

const registrationStore = useRegistrationStore();
const errorStore = useErrorStore();
const stateOptions: Ref<State[]> = ref([]);

onMounted(() => {
    stateOptions.value = registrationStore.states.map(state => {
        return {
            abbr: state.abbr,
            name: state.name,
            selected: false,
        }
    });
})

const canContinue = computed(() => true);
const slidePayload = computed(() => {
    return {
        states: stateOptions.value.filter(state => state.selected).map(state => state.abbr),
    }
});
const validate = () => {
    if (stateOptions.value.filter(state => state.selected).length < 1) {
        errorStore.report('Please select at least one operating state')
        return false;
    }
    
    return true;
};

defineExpose({
    canContinue,
    slidePayload,
    validate,
});

</script>
